import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function FinalCTASection() {
  const { t } = useTranslation();
  return (
    <section className="relative py-24 md:py-32 bg-primary-900 overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute inset-0 opacity-[0.03] bg-[radial-gradient(ellipse_at_top,oklch(var(--accent-500)),transparent_60%)]"></div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1px] h-32 bg-gradient-to-b from-accent-500/20 to-transparent"></div>

      <div className="relative z-10 max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16 text-center">
        <p className="text-accent-400/60 text-[13px] tracking-[0.2em] mb-6 font-label">
          CONTACT
        </p>
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-100 tracking-[0.06em] mb-4">
          {t('home.cta.title')}
        </h2>
        <div className="gold-line mx-auto mb-6"></div>
        <p className="text-[17px] text-foreground-400 leading-relaxed tracking-[0.04em] max-w-xl mx-auto mb-12">
          {t('home.cta.body1')}
          <br />
          {t('home.cta.body2')}
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row justify-center gap-5">
          <Link
            to="/brochure"
            className="btn-glow px-10 py-4 bg-accent-500/90 hover:bg-accent-500 text-primary-900 text-[15px] tracking-[0.1em] font-medium text-center transition-all duration-300 whitespace-nowrap"
          >
            {t('home.cta.brochure')}
          </Link>
          <Link
            to="/contact"
            className="btn-glow px-10 py-4 border border-accent-500/50 text-accent-300 hover:text-accent-200 hover:border-accent-400 hover:bg-accent-500/8 text-[15px] tracking-[0.1em] text-center transition-all duration-300 whitespace-nowrap"
          >
            {t('home.cta.contact')}
          </Link>
        </div>

        {/* Contact Info */}
        <div className="mt-16 flex flex-col md:flex-row justify-center items-center gap-8 md:gap-16 text-[15px] text-foreground-500 tracking-[0.04em]">
          <div className="flex items-center gap-2">
            <i className="ri-phone-line text-accent-500/60"></i>
            <span>{t('home.cta.tel')}<span className="text-foreground-300">{t('home.cta.telNum')}</span></span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-mail-line text-accent-500/60"></i>
            <span>{t('home.cta.mail')}<span className="text-foreground-300">{t('home.cta.mailAddr')}</span></span>
          </div>
        </div>
      </div>
    </section>
  );
}